export enum Location {
  ManassasVA = 'Manassas, VA',
  AlexandriaVA = 'Alexandria, VA (Harmony Animal Hospital)',
  MiddleburgVA = 'Middleburg, VA',
  MarshallVA = 'Marshall, VA',
  FredericksburgVA = 'Fredericksburg, VA',
}
